import React from 'react';

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { StyledBox, StyledDivider, StyledGrid, StyledTypography } from 'styles/common';

import { StyledIcon } from 'constants/icons';

const getTargetRoleNameFromKey = (key) => {
  switch (key) {
    case 'CURRENT_ROLE':
      return 'Current Role';
    case 'NOT_SET':
      return 'Not Set';
    case 'NEW_ROLE':
      return 'New Role';
    default:
      break;
  }
};

export const TargetRoleDonutChartHoverComp = ({ data }) => (
  <StyledBox padding="1rem" width="40ch">
    <StyledGrid>
      <StyledTypography variant="body1" weight={600}>
        Score distribution
      </StyledTypography>
    </StyledGrid>
    <StyledDivider topGutter={2} bottomGutter={2} />
    <StyledGrid direction="column">
      {data.map(({ key, count, color }) => (
        <TargetRoleDonutChartHoverRow key={key} text={key} count={count} color={color} />
      ))}
    </StyledGrid>
  </StyledBox>
);

const TargetRoleDonutChartHoverRow = ({ text, count, color }) => (
  <StyledGrid container>
    <StyledGrid container item xs={7}>
      <StyledIcon size="header" color={color} rightGutter={1}>
        <FiberManualRecordIcon />
      </StyledIcon>
      <StyledTypography variant="body1">{getTargetRoleNameFromKey(text)}</StyledTypography>
    </StyledGrid>
    <StyledGrid container item xs={5} justify="flex-end">
      <StyledTypography variant="body1" color="textSecondary">
        {`${count} Employee`}
      </StyledTypography>
    </StyledGrid>
  </StyledGrid>
);
